<template>
  <div class="relative">
    <div style="height: 150px; overflow: hidden" class="absolute w-full top-full z-0">
      <!-- <img src="@/assets/brand/wavy-bottom.svg" style="height: 100%; width: 100%;" /> -->
      <svg
        width="657"
        height="185"
        viewBox="0 0 657 185"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        preserveAspectRatio="none"
        style="height: 100%; width: 100%"
        class="-mt-4"
      >
        <path
          d="M643 3H14C7.92486 3 3 7.92488 3 14V136.579C3 144.423 10.9282 149.785 18.2077 146.986C31.6738 141.809 56.0238 132.965 83.505 125.419C111.03 117.861 141.494 111.663 167.25 111.663C216.021 111.663 246.911 122.876 285.116 136.744C298.1 141.457 311.928 146.476 327.589 151.466C388.144 170.76 424.541 182 489.75 182C545.71 182 624.924 159.546 646.298 153.173C650.96 151.783 654 147.513 654 142.739V14C654 7.92486 649.075 3 643 3Z"
          :fill="cardFill"
          :stroke="cardFill"
          stroke-width="6"
        />
      </svg>
    </div>
    <div :class="cardClass">
      <div class="px-12 py-8">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WavyCard',
  props: {
    cardClass: {
      type: String,
      default: 'bg-brand-sand -mb-24 z-10 relative rounded-t-lg',
    },
    cardFill: {
      type: String,
      default: '#F8EFE6',
    },
  },
};
</script>
